export default __webpack_public_path__ + "static/media/minus_icon_disabled.e52e73e7.svg";